module.exports = __webpack_public_path__ + "img/frecuencia.3ba7985f.png";